<div class="container">
    <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
      <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
      <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub2}}</h1>
      <!-- <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left"> -->
          <div class="col-md-5 col-lg-4 m-auto text-left px-0">
        <div class="form-group commercial">
          <!--  <div class="col-sm-12" id="commercial">
              <ng-select [items]="businessTypes"
              bindLabel="level1"
              bindValue="level1"
              placeholder="Select"
              [searchable]="false" [clearable]="false"
              (change)="getLevel1(level1);" [(ngModel)]="level1">
              </ng-select>
               <select (change)="getLevel1($event.target.value);" [(ngModel)]="level1" class="dropdown-toggle form-control">
              <option value= "Select" selected disabled>Select</option>
              <option *ngFor="let business of businessTypes" value={{business.level1}}>{{business.level1}}</option>
            </select> 
          </div>-->
          <input [(ngModel)]="level1"   (keyup.enter)="next()"  (ngModelChange)="getCurrentProvider($event)" [typeahead]="energy_providers_list" (keydown.space)="level1 ? null : $event.preventDefault()"
        placeholder="Enter Business Type" value = "{{level1}}" class="form-control" [typeaheadMinLength]="0" (selectItem)="onTypeaheadItemSelect($event)"  [typeaheadOptionsLimit]="energy_providers_list.length" [typeaheadScrollable] = "true"/>
        </div>
  
         
        <div class="form-group" *ngIf="sub_levels.length > 0">
        <!--  <div class="col-sm-12" id="commercial">
             <select (change)="getLevel2($event.target.value);" [(ngModel)]="level2" class="dropdown-toggle form-control">
              <option value= "Select" selected disabled>Select</option>
              <option *ngFor="let sub_level of sub_levels" value={{sub_level.level2}}>{{sub_level.level2}}</option>
            </select> 
            <ng-select [items]="sub_levels"
              bindLabel="level2"
              bindValue="level2"
              placeholder="Select"
              [searchable]="false" [clearable]="false"
              (change)="getLevel2(level2);" [(ngModel)]="level2">
              </ng-select>
          </div>-->
        </div>
        <div class="form-group" *ngIf="sub_levels2.length > 0">
        <!--  <div class="col-sm-12" id="commercial">
             <select (change)="getLevel3($event.target.value);" [(ngModel)]="level3" class="dropdown-toggle form-control">
              <option value= "Select" selected disabled>Select</option>
              <option *ngFor="let sub_level2 of sub_levels2" value={{sub_level2}}>{{sub_level2}}</option>
            </select> 
            <ng-select [items]="sub_levels2"
              placeholder="Select"
              [searchable]="false" [clearable]="false"
              (change)="getLevel3(level3);" [(ngModel)]="level3">
              </ng-select>
          </div>-->
        </div>
        <div class="col-sm-12 text-center">
        <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'combtn': disablebutton}"
          (click)="next();">Next</button>
        </div>
      </div>
      <!-- <div class="row mt-2">
        <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
          <img src="assets/images/flash.png" class="mb-1" />
          <p class="text-center tiphead">BE SURE TO</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
        </div>
      </div> -->
    </div>
  </div>
  <div class="container mobileview pt-3 px-0" [attr.id]="questionObj._id" style="float:left;">
    <div class="d-flex h-100 row col-sm-12 pr-0">
      <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/logo-charcoal.png" />
      </div>
      <div class="col-sm-9 col-9 px-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left">{{question}}</h1>
        </div>
      </div>
    </div>
    <div class="col-12 m-auto pl-0">
      <div class="form-group col-9 px-0 mt-2 pull-right commercial" style="margin-bottom:6px !important" id="commercial">
        <!-- <label class="col-5 col-form-label text-right">Level1</label>
        <div class="col-sm-7 col-7 px-0">
          <select (change)="getLevel1($event.target.value);" [(ngModel)]="level1" class="dropdown-toggle form-control">
            <option *ngFor="let business of businessTypes" value={{business.level1}}>{{business.level1}}</option>
          </select>
        </div> 
        <ng-select [items]="businessTypes"
              bindLabel="level1"
              bindValue="level1"
              placeholder="Select"
              [searchable]="false" [clearable]="false"
              (change)="getLevel1(level1);" [(ngModel)]="level1">
              </ng-select>-->
              
                <!-- <label for="" class="col-form-label text-right">Enter Business Type</label> -->
                <!-- <input type="text" class="form-control focus-none" placeholder="Select Providers" [(ngModel)]="currentProvider" (keydown.space)="currentProvider.length > 0 ? null : $event.preventDefault()" list="dynmiclist" (ngModelChange)="getCurrentProvider($event)"/>
                <datalist id="dynmiclist">
                  <option *ngFor="let currentProvider of energy_providers_list" value={{currentProvider}}>{{currentProvider}}</option>
                </datalist> -->
                <input [(ngModel)]="level1" (keydown.space)="level1 ? null : $event.preventDefault()" [typeahead]="energy_providers_list"
                [typeaheadMinLength]="0" [typeaheadOptionsLimit]="energy_providers_list.length" [typeaheadScrollable] = "true" (ngModelChange)="getCurrentProvider($event)"
                placeholder="Enter Business Type"class="form-control"/>
              
      </div>
      <div class="form-group col-9 px-0 pull-right" style="margin-bottom:6px !important" *ngIf="sub_levels.length > 0" id="commercial">
        <!-- <label class="col-5 col-form-label text-right">Level2</label>
        <div class="col-7 px-0">
          <select (change)="getLevel2($event.target.value);" [(ngModel)]="level2" class="dropdown-toggle form-control">
            <option *ngFor="let sub_level of sub_levels" value={{sub_level.level2}}>{{sub_level.level2}}</option>
          </select>
        </div> 
        <ng-select [items]="sub_levels"
              bindLabel="level2"
              bindValue="level2"
              placeholder="Select"
              [searchable]="false" [clearable]="false"
              (change)="getLevel2(level2);" [(ngModel)]="level2">
              </ng-select>-->
      </div>
      <div class="form-group col-9 px-0 pull-right" style="margin-bottom:6px !important" *ngIf="sub_levels2.length > 0" id="commercial">
        <!-- <label class="col-5 col-form-label text-right">Level3</label>
        <div class="col-7 px-0 mt-2">
          <select (change)="getLevel3($event.target.value);" [(ngModel)]="level3" class="dropdown-toggle form-control">
            <option *ngFor="let sub_level2 of sub_levels2" value={{sub_level2}}>{{sub_level2}}</option>
          </select>
        </div> 
        <ng-select [items]="sub_levels2"
              placeholder="Select"
              [searchable]="false" [clearable]="false"
              (change)="getLevel3(level3);" [(ngModel)]="level3">
              </ng-select>-->
      </div>
      <br />
      <div class="text-right"style="width:100% !important; float: left;">
        <div *ngIf="user_bot" class="ash_box text-right mt-2">
          <h1 class="ansMob text-right" *ngIf="level1">{{level1}}</h1>
          <!-- <h1 class="ansMob text-right" *ngIf="level2">{{level2}}</h1>
          <h1 class="ansMob text-right" *ngIf="level3">{{level3}}</h1> -->
        </div>
      </div>
    </div>
    <div class="col-12 mt-3" style="float:left; margin-bottom: 1.9rem!important;">
      <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">BE SURE TO</p>
        <p class="text-center tipmes">{{questionObj.tip}}</p>
      </div>
    </div>
    <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
      <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/logo-charcoal.png" />
      </div>
      <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
          <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
      </div>
    </div>
  </div>